export const TEAM_GROUP_SET_INITIAL_STATE = 'TEAM_GROUP_SET_INITIAL_STATE';
export const TEAM_GROUP_FIND_ALL = 'TEAM_GROUP_FIND_ALL';
export const TEAM_GROUP_VIEW = 'TEAM_GROUP_VIEW';
